{
    "PreviewHeader": "Visualizar",
    "PreviewValueInvalid": "[Formato Inválido]",
    "NAME": "Preview"
}